import React, { useMemo, useState } from "react"

import { useSelector, useDispatch } from "react-redux"
import {
  Alert,
  CardBody,
  Container,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
  Card,
  Col,
  CardTitle,
  Badge,
  Modal,
  UncontrolledTooltip,
  Button,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  InputGroup,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik, Field } from "formik"
import { Link, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"

//import components
import TableContainer from "components/Common/TableContainer"
import { useEffect } from "react"

// slice
import {
  fetchBookingDetails,
  deleteBookingDetails,
  createBookingDetails,
  updateBookingDetails,
  resetBookingDetails,
} from "toolkitStore/eventMSlice/SeatAllocationSlice"
import SeatAllocation from "./SeatAllocation"
import { fetchEvent } from "toolkitStore/eventMSlice/eventSlice"

 
const PricingBox = ({ title, children }) => (
  <div className="p-3 mb-4" style={{ border: "2px solid #9ccc65", borderRadius: 6 }}>
    <h6 className="mb-3">{title}</h6>
    {children}
  </div>
);

const FoodRow = ({ title, children }) => (
  <div className="mb-3">
    <strong>{title}</strong>
    {children}
  </div>
);

const AdultChildInputs = ({ adultField, childField, validation }) => {
  // Use lodash get to ensure stable value tracking
  const adultVal = _.get(validation.values, adultField, "");
  const childVal = _.get(validation.values, childField, "");

  return (
    <div className="row">
      <div className="col-6">
        <label className="small text-muted">Adult Cost</label>
        <Input
          type="number"
          min={0}
          name={adultField}
          value={adultVal}
          onChange={e => validation.setFieldValue(adultField, e.target.value)}
        />
      </div>
      <div className="col-6">
        <label className="small text-muted">Child Cost</label>
        <Input
          type="number"
          min={0}
          name={childField}
          value={childVal}
          onChange={e => validation.setFieldValue(childField, e.target.value)}
        />
      </div>
    </div>
  );
};

const FoodOnlyRow = ({ vegField, nonVegField, validation, showVeg, showNonVeg }) => (
  <div className="row">
    {showVeg && (
      <div className="col-6">
        <label>Veg</label>
        <Input
          type="number"
          min={0}
          value={_.get(validation.values, vegField, "")}
          onChange={e => validation.setFieldValue(vegField, e.target.value)}
        />
      </div>
    )}
    {showNonVeg && (
      <div className="col-6">
        <label>Non Veg</label>
        <Input
          type="number"
          min={0}
          value={_.get(validation.values, nonVegField, "")}
          onChange={e => validation.setFieldValue(nonVegField, e.target.value)}
        />
      </div>
    )}
  </div>
);
 
function SeatAllocationList(props) {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const event_id_c = JSON.parse(localStorage.getItem("event_id"))
  // console.log("event_id", event_id_c)
  const venue_id_c = JSON.parse(localStorage.getItem("venue_id"))
  // console.log("venue_id", venue_id_c)

  const { BookingDetailsList, BookingDetailsisSuccessfully, isUserEdit } =
    useSelector(state => state.SeatAllocationReducer)

  //Offacanvas
  const [isRight, setIsRight] = useState(false)
  const toggleRightCanvas = () => {
    setIsRight(!isRight)
  }

  //Delete
  const [modal_backdrop, setmodal_backdrop] = useState(false)
  const [delete_data, SetDelete_data] = useState()

  const [selectedData, SetSelectData] = useState()
  const [is_reserved, setIsReserved] = useState(false)

  const [isBookTypeSelected, setBookTypeSelected] = useState(false)

  const { newEventList } = useSelector(state => state.EventReducer)
  const currentEvent = newEventList?.find(ev => ev._id === event_id_c?.EventId)
 

  const isEventTypeEvent = currentEvent?.eventTypeId === "ET002"
const isEventTypeFood = currentEvent?.eventTypeId === "ET001"
const isEventTypeEventWithFood = currentEvent?.eventTypeId === "ET003"

 
const isFreeEvent = currentEvent?.type === "FREE";
const isPaidFood =
  currentEvent?.freeFoodOption === "WITH_FOOD" &&
  currentEvent?.freeFoodType === "PAID_FOOD";
const foodTypeId = currentEvent?.foodTypeId || "";

const isFoodTypeVeg = foodTypeId === "FT001";
const isFoodTypeNonVeg = foodTypeId === "FT002";
const isFoodTypeBoth = foodTypeId === "FT003";

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  function tog_backdrop() {
    setmodal_backdrop(!modal_backdrop)
    removeBodyCss()
  }
  useEffect(() => {
    if (newEventList.length > 0) {
      console.log(`123---${currentEvent?.eventType}`)
    } else {
      console.log("newEventList is empty")
    }
  })
  useEffect(() => {
    dispatch(fetchEvent())
    if (BookingDetailsisSuccessfully) {
      setIsRight(false)
      validation.resetForm()
    }
    dispatch(resetBookingDetails())
  }, [BookingDetailsisSuccessfully])

  const Cancel = e => {
    e.preventDefault()
    localStorage.removeItem("editUser")
    SetSelectData("")
    setIsRight(false)
  }

  useEffect(() => {
    dispatch(
      fetchBookingDetails({
        master_event_id: event_id_c.EventId,
        master_venue_id: venue_id_c.VenueId,
      })
    )
  }, [isRight, modal_backdrop])
 
  const columns = useMemo(() => {
    const hasFreeEventAdultChildData = key =>
  BookingDetailsList.some(
    item => item[key] !== null && item[key] !== "" && item[key] !== 0
  );

  if (!BookingDetailsList || BookingDetailsList.length === 0) return [];

  // Find one record to check which fields exist
  const sample = BookingDetailsList[0];

  // Helper to check if column has at least one non-null value
  const hasData = key =>
    BookingDetailsList.some(item => item[key] !== null && item[key] !== "" && item[key] !== 0);

  const baseColumns = [
    {
      Header: "Booking Type",
      accessor: "booking_type",
      disableFilters: true,
    },
  ];

  /* =====================================================
   FREE EVENT + PAID FOOD + ADULT / CHILD TABLE COLUMNS
===================================================== */
if (isFreeEvent && isPaidFood) {
  // ===== VEG =====
  if (hasFreeEventAdultChildData("f_m_adult_veg_cost")) {
    baseColumns.push({
      Header: "Member Veg (Adult)",
      accessor: "f_m_adult_veg_cost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }

  if (hasFreeEventAdultChildData("f_m_child_veg_cost")) {
    baseColumns.push({
      Header: "Member Veg (Child)",
      accessor: "f_m_child_veg_cost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }

  if (hasFreeEventAdultChildData("f_nm_adult_veg_cost")) {
    baseColumns.push({
      Header: "Non-Member Veg (Adult)",
      accessor: "f_nm_adult_veg_cost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }

  if (hasFreeEventAdultChildData("f_nm_child_veg_cost")) {
    baseColumns.push({
      Header: "Non-Member Veg (Child)",
      accessor: "f_nm_child_veg_cost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }

  // ===== NON-VEG =====
  if (hasFreeEventAdultChildData("f_m_adult_nonveg_cost")) {
    baseColumns.push({
      Header: "Member Non-Veg (Adult)",
      accessor: "f_m_adult_nonveg_cost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }

  if (hasFreeEventAdultChildData("f_m_child_nonveg_cost")) {
    baseColumns.push({
      Header: "Member Non-Veg (Child)",
      accessor: "f_m_child_nonveg_cost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }

  if (hasFreeEventAdultChildData("f_nm_adult_nonveg_cost")) {
    baseColumns.push({
      Header: "Non-Member Non-Veg (Adult)",
      accessor: "f_nm_adult_nonveg_cost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }

  if (hasFreeEventAdultChildData("f_nm_child_nonveg_cost")) {
    baseColumns.push({
      Header: "Non-Member Non-Veg (Child)",
      accessor: "f_nm_child_nonveg_cost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }

  // 
   if (hasFreeEventAdultChildData("f_m_vegcost")) {
    baseColumns.push({
      Header: "Member Veg ",
      accessor: "f_m_vegcost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }

   if (hasFreeEventAdultChildData("f_m_nonvegcost")) {
    baseColumns.push({
      Header: "Member Non-Veg ",
      accessor: "f_m_nonvegcost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }

  if (hasFreeEventAdultChildData("f_nm_vegcost")) {
    baseColumns.push({
      Header: "Non-Member Veg ",
      accessor: "f_nm_vegcost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }

   if (hasFreeEventAdultChildData("f_nm_nonvegcost")) {
    baseColumns.push({
      Header: "Non-Member Non-Veg ",
      accessor: "f_nm_nonvegcost",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.value}</div>,
    });
  }
}


  // Add only if data is present
  if (hasData("adult_price")) {
    baseColumns.push({
      Header: "Adult Ticket Price",
      accessor: "adult_price",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.row.original.adult_price}</div>,
    });
  }

  if (hasData("kids_price")) {
    baseColumns.push({
      Header: "Kids Ticket Price",
      accessor: "kids_price",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.row.original.kids_price}</div>,
    });
  }

  if (hasData("n_adult_price")) {
    baseColumns.push({
      Header: "Non Member Adult Price",
      accessor: "n_adult_price",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.row.original.n_adult_price}</div>,
    });
  }

  if (hasData("n_kids_price")) {
    baseColumns.push({
      Header: "Non Member Kids Price",
      accessor: "n_kids_price",
      disableFilters: true,
      Cell: cellProps => <div>$ {cellProps.row.original.n_kids_price}</div>,
    });
  }

  // Food / Event with food columns
  if (isEventTypeFood || isEventTypeEventWithFood) {
    if (hasData("veg_price")) {
      baseColumns.push({
        Header: "Veg",
        accessor: "veg_price",
        disableFilters: true,
        Cell: cellProps => <div>$ {cellProps.row.original.veg_price}</div>,
      });
    }

    if (hasData("nonveg_price")) {
      baseColumns.push({
        Header: "Non-Veg",
        accessor: "nonveg_price",
        disableFilters: true,
        Cell: cellProps => <div>$ {cellProps.row.original.nonveg_price}</div>,
      });
    }

    if (hasData("nm_veg_price")) {
      baseColumns.push({
        Header: "Non Member Veg",
        accessor: "nm_veg_price",
        disableFilters: true,
        Cell: cellProps => <div>$ {cellProps.row.original.nm_veg_price}</div>,
      });
    }

    if (hasData("nm_nonveg_price")) {
      baseColumns.push({
        Header: "Non Member Non-Veg",
        accessor: "nm_nonveg_price",
        disableFilters: true,
        Cell: cellProps => <div>$ {cellProps.row.original.nm_nonveg_price}</div>,
      });
    }
  }

  // Action Column
  baseColumns.push({
    Header: "Action",
    accessor: "actions",
    disableFilters: true,
    Cell: cellProps => {
      const SData = cellProps.row.original;
      return (
        <ul className="list-unstyled hstack d-flex gap-1 mb-0">
          <Link
            to="#!"
            className="btn btn-sm btn-soft-info"
            onClick={e => {
              e.preventDefault();
              toggleRightCanvas();
              SetSelectData(SData);
              return false;
            }}
          >
            <i className="mdi mdi-pencil-outline" id="edittooltip" />
            <UncontrolledTooltip placement="top" target="edittooltip">
              Edit
            </UncontrolledTooltip>
          </Link>
          <Link
            to="#"
            className="btn btn-sm btn-soft-danger"
            onClick={e => {
              e.preventDefault();
              tog_backdrop();
              SetDelete_data({ _id: SData._id });
              return false;
            }}
          >
            <i className="mdi mdi-delete-outline" id="deletetooltip" />
            <UncontrolledTooltip placement="top" target="deletetooltip">
              Delete
            </UncontrolledTooltip>
          </Link>
        </ul>
      );
    },
  });

  return baseColumns;
}, [BookingDetailsList, isEventTypeFood, isEventTypeEventWithFood]);



const validation = useFormik({
  enableReinitialize: true,

  initialValues: {
    master_event_id: selectedData?.master_event_id || event_id_c.EventId,
    master_venue_id: selectedData?.master_venue_id || venue_id_c.VenueId,
    category: selectedData?.category || "",
    no_of_tickets: selectedData?.no_of_tickets || "",
    adult_price: selectedData?.adult_price || "",
    kids_price: selectedData?.kids_price || "",
    n_adult_price: selectedData?.n_adult_price || "",
    n_kids_price: selectedData?.n_kids_price || "",
    veg_price: selectedData?.veg_price || "",
    nonveg_price: selectedData?.nonveg_price || "",
    nm_veg_price: selectedData?.nm_veg_price || "",
    nm_nonveg_price: selectedData?.nm_nonveg_price || "",
    is_reserved: selectedData?.is_reserved || false,
    active_status: selectedData?.active_status || "",
    booking_type: selectedData?.booking_type || "",
    start_date: selectedData?.start_date || "",
    end_date: selectedData?.end_date || "",

        /* ================= FREE EVENT – FOOD ONLY ================= */

  
         freeEventAdultChildPricing: {
        veg: {
          adult: {
            member: selectedData?.f_m_adult_veg_cost || "",
            nonMember: selectedData?.f_nm_adult_veg_cost || "",
          },
          child: {
            member: selectedData?.f_m_child_veg_cost || "",
            nonMember: selectedData?.f_nm_child_veg_cost || "",
          },
        },
        nonVeg: {
          adult: {
            member: selectedData?.f_m_adult_nonveg_cost || "",
            nonMember: selectedData?.f_nm_adult_nonveg_cost || "",
          },
          child: {
            member: selectedData?.f_m_child_nonveg_cost || "",
            nonMember: selectedData?.f_nm_child_nonveg_cost || "",
          },
        },
      },
      freeEventFoodPricing: {
        veg: {
          member: selectedData?.f_m_vegcost || "",
          nonMember: selectedData?.f_nm_vegcost || "",
        },
        nonVeg: {
          member: selectedData?.f_m_nonvegcost || "",
          nonMember: selectedData?.f_nm_nonvegcost || "",
        },
      },
  },

  validationSchema: Yup.object({
    //  EVENT / EVENTWITHFOOD require ticket prices
    adult_price: Yup.string()
      .nullable()
      .test(
        "required-if-event",
        "Enter Member Adult Price",
        () => isEventTypeEvent || isEventTypeEventWithFood ? true : true
      )
      .when([], {
        is: () => isEventTypeEvent || isEventTypeEventWithFood,
        then: schema => schema.required("Enter Member Adult Price"),
      }),

    kids_price: Yup.string().when([], {
      is: () => isEventTypeEvent || isEventTypeEventWithFood,
      then: schema => schema.required("Enter Member Kids Price"),
      otherwise: schema => schema.notRequired(),
    }),

    n_adult_price: Yup.string().when([], {
      is: () => isEventTypeEvent || isEventTypeEventWithFood,
      then: schema => schema.required("Enter Non Member Adult Price"),
      otherwise: schema => schema.notRequired(),
    }),

    n_kids_price: Yup.string().when([], {
      is: () => isEventTypeEvent || isEventTypeEventWithFood,
      then: schema => schema.required("Enter Non Member Kids Price"),
      otherwise: schema => schema.notRequired(),
    }),

    //  FOOD / EVENTWITHFOOD validation based on foodType
    veg_price: Yup.string().test(
      "required-if-veg",
      "Enter Veg Price",
      function (value) {
        if (isEventTypeFood || isEventTypeEventWithFood) {
          if (foodTypeId === "FT001" || foodTypeId === "FT003") {
            return !!value;
          }
        }
        return true;
      }
    ),

    nonveg_price: Yup.string().test(
      "required-if-nonveg",
      "Enter Non-Veg Price",
      function (value) {
        if (isEventTypeFood || isEventTypeEventWithFood) {
          if (foodTypeId === "FT002" || foodTypeId === "FT003") {
            return !!value;
          }
        }
        return true;
      }
    ),

    nm_veg_price: Yup.string().test(
      "required-if-nm-veg",
      "Enter Non Member Veg Price",
      function (value) {
        if (isEventTypeFood || isEventTypeEventWithFood) {
          if (foodTypeId === "FT001" || foodTypeId === "FT003") {
            return !!value;
          }
        }
        return true;
      }
    ),

    nm_nonveg_price: Yup.string().test(
      "required-if-nm-nonveg",
      "Enter Non Member Non-Veg Price",
      function (value) {
        if (isEventTypeFood || isEventTypeEventWithFood) {
          if (foodTypeId === "FT002" || foodTypeId === "FT003") {
            return !!value;
          }
        }
        return true;
      }
    ),

    booking_type: Yup.string().required("Select Booking Type"),
    start_date: Yup.date().required("Start Date is required"),
    end_date: Yup.date().required("End Date is required"),
  }),

 
  onSubmit: (values) => {
  console.log("Submitting values:", values);

  // ✅ Determine which fields should remain based on event + food type
  const isEventWithFood = isEventTypeEventWithFood;
  const isEventOnly = isEventTypeEvent;
  const isFoodOnly = isEventTypeFood;
  const isVeg = isFoodTypeVeg;
  const isNonVeg = isFoodTypeNonVeg;
  const isBoth = isFoodTypeBoth;

  // Start with all nulls (default reset)
  const cleanedValues = {
    veg_price: null,
    nonveg_price: null,
    nm_veg_price: null,
    nm_nonveg_price: null,
    adult_price: null,
    kids_price: null,
    n_adult_price: null,
    n_kids_price: null,
  };

  // ✅ Set only what’s visible (keep values from form)
  if (isEventOnly || isEventWithFood) {
    cleanedValues.adult_price = values.adult_price || null;
    cleanedValues.kids_price = values.kids_price || null;
    cleanedValues.n_adult_price = values.n_adult_price || null;
    cleanedValues.n_kids_price = values.n_kids_price || null;
  }

  if (isFoodOnly || isEventWithFood) {
    if (isVeg || isBoth) {
      cleanedValues.veg_price = values.veg_price || null;
      cleanedValues.nm_veg_price = values.nm_veg_price || null;
    }
    if (isNonVeg || isBoth) {
      cleanedValues.nonveg_price = values.nonveg_price || null;
      cleanedValues.nm_nonveg_price = values.nm_nonveg_price || null;
    }
  }

  // ✅ Keep other non-price fields
  const payload = {
    ...values,
    ...cleanedValues,
  };

    payload.f_m_vegcost = null;
  payload.f_nm_vegcost = null;
  payload.f_m_nonvegcost = null;
  payload.f_nm_nonvegcost = null;

  // Free-event adult / child food
  payload.f_m_adult_veg_cost = null;
  payload.f_m_child_veg_cost = null;
  payload.f_nm_adult_veg_cost = null;
  payload.f_nm_child_veg_cost = null;

  payload.f_m_adult_nonveg_cost = null;
  payload.f_m_child_nonveg_cost = null;
  payload.f_nm_adult_nonveg_cost = null;
  payload.f_nm_child_nonveg_cost = null;
  /* =================================================
   FREE EVENT + PAID FOOD (ADD-ON LOGIC)
================================================= */
if (isFreeEvent && isPaidFood) {
  // 🔴 Free event → ticket prices must be null
  payload.adult_price = null;
  payload.kids_price = null;
  payload.n_adult_price = null;
  payload.n_kids_price = null;

  // 🔹 Adult / Child food pricing
  if (currentEvent?.includeTicketType === "ADULT_CHILD") {
    // Clear flat food
    payload.veg_price = null;
    payload.nonveg_price = null;
    payload.nm_veg_price = null;
    payload.nm_nonveg_price = null;

    if (isFoodTypeVeg || isFoodTypeBoth) {
      payload.f_m_adult_veg_cost =
        values.freeEventAdultChildPricing.veg.adult.member || null;
      payload.f_m_child_veg_cost =
        values.freeEventAdultChildPricing.veg.child.member || null;
      payload.f_nm_adult_veg_cost =
        values.freeEventAdultChildPricing.veg.adult.nonMember || null;
      payload.f_nm_child_veg_cost =
        values.freeEventAdultChildPricing.veg.child.nonMember || null;
    }

    if (isFoodTypeNonVeg || isFoodTypeBoth) {
      payload.f_m_adult_nonveg_cost =
        values.freeEventAdultChildPricing.nonVeg.adult.member || null;
      payload.f_m_child_nonveg_cost =
        values.freeEventAdultChildPricing.nonVeg.child.member || null;
      payload.f_nm_adult_nonveg_cost =
        values.freeEventAdultChildPricing.nonVeg.adult.nonMember || null;
      payload.f_nm_child_nonveg_cost =
        values.freeEventAdultChildPricing.nonVeg.child.nonMember || null;
    }
  }

  // 🔹 Flat food pricing (NO adult/child)
  else {
    if (isFoodTypeVeg || isFoodTypeBoth) {
      payload.f_m_vegcost =
        values.freeEventFoodPricing.veg.member || null;
      payload.f_nm_vegcost =
        values.freeEventFoodPricing.veg.nonMember || null;
    }

    if (isFoodTypeNonVeg || isFoodTypeBoth) {
      payload.f_m_nonvegcost =
        values.freeEventFoodPricing.nonVeg.member || null;
      payload.f_nm_nonvegcost =
        values.freeEventFoodPricing.nonVeg.nonMember || null;
    }
  }
}



  // ✅ Add ID if updating existing record
  if (selectedData?._id) {
    payload._id = selectedData._id;
    dispatch(updateBookingDetails(payload));
  } else {
    dispatch(createBookingDetails(payload));
  }
},

});


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="" breadcrumbItem="TICKETS ALLOCATION" />
          <Row className="">
            <Card>
              <CardBody className="border-botton">
                <div className="d-flex align-items-center">
                  <div className="mb-1 flex-grow-1 ">
                    <h5 className="card-title text-primary">
                      {event_id_c.EventName + " / " + venue_id_c.VenueName}
                    </h5>
                    <div>Maximum Tickets - {venue_id_c.MaxTicket}</div>
                  </div>

                  <div className="mb-1 flex-shrink-0">
                    <Link
                      to="#!"
                      onClick={e => {
                        setIsRight(true)
                        setBookTypeSelected(false)
                        localStorage.removeItem("editUser")
                      }}
                      className="btn btn-primary me-1"
                    >
                      Add Ticket allocation
                    </Link>
                    <Link
                      to="#"
                      className="btn btn-secondary me-1"
                      onClick={e => {
                        e.preventDefault()
                        history.back()
                      }}
                    >
                      Back
                    </Link>
                    <Link
                      to="#!"
                      onClick={() => {
                        dispatch(
                          fetchBookingDetails({
                            master_event_id: event_id_c.EventId,
                            master_venue_id: venue_id_c.VenueId,
                          })
                        )
                      }}
                      className="btn btn-light me-1"
                    >
                      <i className="mdi mdi-refresh"></i>
                    </Link>
                  </div>
                </div>

                <Row>
                  <div className="container-fluid">
                    <TableContainer
                      columns={columns}
                      data={BookingDetailsList}
                      isGlobalFilter={false}
                      isAddOptions={false}
                      customPageSize={30}
                      isJobListGlobalFilter={false}
                      // className="custom-header-css"
                    />
                  </div>
                </Row>
                {BookingDetailsList.length > 10 ? (
                  <Row>
                    <Col xs="12">
                      <div className="text-center my-3">
                        <Link to="#" className="text-success">
                          <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                          Load more
                        </Link>
                      </div>
                    </Col>
                  </Row>
                ) : null}
              </CardBody>
            </Card>
          </Row>

          <Offcanvas
            isOpen={isRight}
            direction="end"
            toggle={toggleRightCanvas}
          >
            <OffcanvasHeader
              toggle={toggleRightCanvas}
              style={{ borderBottom: "1px solid #dedede" }}
            >
              Add / Edit Ticket Allocation
            </OffcanvasHeader>
            <OffcanvasBody>
              <Form
                onSubmit={event => {
                  event.preventDefault()
                  validation.handleSubmit()
                }}
              >
                <Row>
                  <div className="row">
                    <div className="py-1">
                      <label className="text-secondary text-opacity-75">
                        Booking Type
                      </label>
                    </div>
                    <div
                      className="mb-3 py-2 col-12 d-flex flex-row align-items-center"
                      style={{
                        borderRadius: 8,
                        marginLeft: 10,
                        border: "1px solid #ced4da",
                      }}
                    >
                      <div className="me-3 d-flex justify-content-center">
                        <input
                          type="radio"
                          id="early-bird"
                          className="me-2"
                          name="booking_type"
                          value="early bird"
                          onChange={e => {
                            validation.setFieldValue(
                              "booking_type",
                              e.target.value
                            )
                            setBookTypeSelected(true)
                          }}
                        />
                        <label htmlFor="early-bird" style={{ marginBottom: 0 }}>
                          Early Bird
                        </label>
                      </div>
                      <div className="d-flex justify-content-center">
                        <input
                          style={{ marginRight: "10px" }}
                          type="radio"
                          id="standard"
                          name="booking_type"
                          value="standard"
                          onChange={e => {
                            validation.setFieldValue(
                              "booking_type",
                              e.target.value
                            )
                            setBookTypeSelected(true)
                          }}
                        />
                        <label htmlFor="standard" style={{ marginBottom: 0 }}>
                          Standard
                        </label>
                      </div>
                    </div>
                  </div>

                  {isBookTypeSelected && (
                    <div>
                      <Col className="col-12 d-flex flex-wrap justify-content-between">
                       

                        <div className="mb-3 col-12">
                          <Label
                            htmlFor="start_date"
                            className="text-secondary text-opacity-75"
                          >
                            Booking Started On
                          </Label>
                          <Input
                            name="start_date"
                            className={`form-control`}
                            type="date"
                            value={
                                  validation.values.start_date
                                    ? validation.values.start_date.split("T")[0]
                                    : ""
                                }

                            // defaultValue={validation.values.start_date || ""}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.start_date &&
                              validation.errors.start_date
                                ? true
                                : false
                            }
                          />
                          {validation.touched.start_date &&
                          validation.errors.start_date ? (
                            <FormFeedback
                              type="invalid"
                              style={{ fontSize: "12px" }}
                            >
                              {validation.errors.start_date}
                            </FormFeedback>
                          ) : null}
                        </div>
                        {/* Event-- and also eventwithfood */}

                        {(isEventTypeEvent || isEventTypeEventWithFood)&&(
                          <div
                          className="row p-2 m-0 mb-3"
                          style={{
                            borderRadius: 8,
                            border: "1px solid #ced4da",
                          }}
                        >
                          <div className="py-1">
                            <label className="text-secondary text-opacity-75">
                              Member Ticket Price
                            </label>
                          </div>
                          <div className="mb-3 col-6">
                            <div className="">
                              <label htmlFor="adult_price">Adult</label>
                              <InputGroup>
                                <div className="input-group-text">$</div>
                                <Input
                                  name="adult_price"
                                  className={`form-control`}
                                  placeholder="Price"
                                  type="number"
                                  min={1}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.adult_price || ""}
                                  invalid={
                                    validation.touched.adult_price &&
                                    validation.errors.adult_price
                                      ? true
                                      : false
                                  }
                                />
                              </InputGroup>
                              {validation.touched.adult_price &&
                              validation.errors.adult_price ? (
                                <FormFeedback
                                  type="invalid"
                                  style={{ fontSize: "12px" }}
                                >
                                  {validation.errors.adult_price}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>
                          <div className="mb-3 col-6">
                            <div>
                              <label htmlFor="kids_price">Kids</label>
                              <InputGroup>
                                <div className="input-group-text">$</div>

                                <Input
                                  name="kids_price"
                                  className={`form-control`}
                                  placeholder="Price"
                                  type="number"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.kids_price || ""}
                                  invalid={
                                    validation.touched.kids_price &&
                                    validation.errors.kids_price
                                      ? true
                                      : false
                                  }
                                />
                              </InputGroup>
                              {validation.touched.kids_price &&
                              validation.errors.kids_price ? (
                                <FormFeedback
                                  type="invalid"
                                  style={{ fontSize: "12px" }}
                                >
                                  {validation.errors.kids_price}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </div>)}

                        {(isEventTypeEvent || isEventTypeEventWithFood)&&(<div
                          className="row p-2 m-0 mb-3"
                          style={{
                            borderRadius: 8,
                            border: "1px solid #ced4da",
                          }}
                        >
                          <div className="py-1">
                            <label className="text-secondary text-opacity-75">
                              Non Member Ticket Price
                            </label>
                          </div>
                          <div className="mb-3 col-6">
                            <div className="">
                              <label htmlFor="n_adult_price">Adult</label>
                              <InputGroup>
                                <div className="input-group-text">$</div>
                                <Input
                                  name="n_adult_price"
                                  className={`form-control`}
                                  placeholder="Price"
                                  type="number"
                                  min={1}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.n_adult_price || ""}
                                  invalid={
                                    validation.touched.n_adult_price &&
                                    validation.errors.n_adult_price
                                      ? true
                                      : false
                                  }
                                />
                              </InputGroup>
                              {validation.touched.n_adult_price &&
                              validation.errors.n_adult_price ? (
                                <FormFeedback
                                  type="invalid"
                                  style={{ fontSize: "12px" }}
                                >
                                  {validation.errors.n_adult_price}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>
                          <div className="mb-3 col-6">
                            <div>
                              <label htmlFor="n_kids_price">Kids</label>
                              <InputGroup>
                                <div className="input-group-text">$</div>

                                <Input
                                  name="n_kids_price"
                                  className={`form-control`}
                                  placeholder="Price"
                                  type="number"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.n_kids_price || ""}
                                  invalid={
                                    validation.touched.n_kids_price &&
                                    validation.errors.n_kids_price
                                      ? true
                                      : false
                                  }
                                />
                              </InputGroup>
                              {validation.touched.n_kids_price &&
                              validation.errors.n_kids_price ? (
                                <FormFeedback
                                  type="invalid"
                                  style={{ fontSize: "12px" }}
                                >
                                  {validation.errors.n_kids_price}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </div>)}

                        {/* FOOD --also eventwithfood */}

                        {(isEventTypeFood||isEventTypeEventWithFood)&&(
                          <div
                          className="row p-2 m-0 mb-3"
                          style={{
                            borderRadius: 8,
                            border: "1px solid #ced4da",
                          }}
                        >
                          <div className="py-1">
                            <label className="text-secondary text-opacity-75">
                              Member Food Price
                            </label>
                          </div>
                          {(isFoodTypeVeg || isFoodTypeBoth) && (
                          <div className="mb-3 col-6">
                            <div className="">
                              <label htmlFor="veg_price">veg</label>
                              <InputGroup>
                                <div className="input-group-text">$</div>
                                <Input
                                  name="veg_price"
                                  className={`form-control`}
                                  placeholder="Price"
                                  type="number"
                                  min={1}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.veg_price || ""}
                                  invalid={
                                    validation.touched.veg_price &&
                                    validation.errors.veg_price
                                      ? true
                                      : false
                                  }
                                />
                              </InputGroup>
                              {validation.touched.veg_price &&
                              validation.errors.veg_price ? (
                                <FormFeedback
                                  type="invalid"
                                  style={{ fontSize: "12px" }}
                                >
                                  {validation.errors.veg_price}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>)}
                          {(isFoodTypeNonVeg || isFoodTypeBoth) && (
                          <div className="mb-3 col-6">
                            <div>
                              <label htmlFor="nonveg_price">non-veg</label>
                              <InputGroup>
                                <div className="input-group-text">$</div>

                                <Input
                                  name="nonveg_price"
                                  className={`form-control`}
                                  placeholder="Price"
                                  type="number"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.nonveg_price || ""}
                                  invalid={
                                    validation.touched.nonveg_price &&
                                    validation.errors.nonveg_price
                                      ? true
                                      : false
                                  }
                                />
                              </InputGroup>
                              {validation.touched.nonveg_price &&
                              validation.errors.nonveg_price ? (
                                <FormFeedback
                                  type="invalid"
                                  style={{ fontSize: "12px" }}
                                >
                                  {validation.errors.nonveg_price}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>)}
                        </div>)}

                        {(isEventTypeFood||isEventTypeEventWithFood)&&(<div
                          className="row p-2 m-0 mb-3"
                          style={{
                            borderRadius: 8,
                            border: "1px solid #ced4da",
                          }}
                        >
                          <div className="py-1">
                            <label className="text-secondary text-opacity-75">
                              Non Member Food Price
                            </label>
                          </div>
                          {(isFoodTypeVeg || isFoodTypeBoth) && (
                          <div className="mb-3 col-6">
                            <div className="">
                              <label htmlFor="nm_veg_price">veg</label>
                              <InputGroup>
                                <div className="input-group-text">$</div>
                                <Input
                                  name="nm_veg_price"
                                  className={`form-control`}
                                  placeholder="Price"
                                  type="number"
                                  min={1}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.nm_veg_price || ""}
                                  invalid={
                                    validation.touched.nm_veg_price &&
                                    validation.errors.nm_veg_price
                                      ? true
                                      : false
                                  }
                                />
                              </InputGroup>
                              {validation.touched.nm_veg_price &&
                              validation.errors.nm_veg_price ? (
                                <FormFeedback
                                  type="invalid"
                                  style={{ fontSize: "12px" }}
                                >
                                  {validation.errors.nm_veg_price}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>)}
                          {(isFoodTypeNonVeg || isFoodTypeBoth) && (
                          <div className="mb-3 col-6">
                            <div>
                              <label htmlFor="nm_nonveg_price">non-veg</label>
                              <InputGroup>
                                <div className="input-group-text">$</div>

                                <Input
                                  name="nm_nonveg_price"
                                  className={`form-control`}
                                  placeholder="Price"
                                  type="number"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.nm_nonveg_price || ""}
                                  invalid={
                                    validation.touched.nm_nonveg_price &&
                                    validation.errors.nm_nonveg_price
                                      ? true
                                      : false
                                  }
                                />
                              </InputGroup>
                              {validation.touched.nm_nonveg_price &&
                              validation.errors.nm_nonveg_price ? (
                                <FormFeedback
                                  type="invalid"
                                  style={{ fontSize: "12px" }}
                                >
                                  {validation.errors.nm_nonveg_price}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>)}
                        </div>)}

                        {isFreeEvent && isPaidFood && (
  <>
    {/* ================= MEMBER ================= */}
    <PricingBox title="Member">
      {currentEvent?.includeTicketType === "ADULT_CHILD" ? (
        <>
          {(isFoodTypeVeg || isFoodTypeBoth) && (
           <FoodRow title="Veg">
  <AdultChildInputs
    adultField="freeEventAdultChildPricing.veg.adult.member"
    childField="freeEventAdultChildPricing.veg.child.member"
    validation={validation}
  />
</FoodRow>
          )}

          {(isFoodTypeNonVeg || isFoodTypeBoth) && (
            <FoodRow title="Non Veg">
  <AdultChildInputs
    adultField="freeEventAdultChildPricing.nonVeg.adult.member"
    childField="freeEventAdultChildPricing.nonVeg.child.member"
    validation={validation}
  />
</FoodRow>
          )}
        </>
      ) : (
        <FoodOnlyRow
          vegField="freeEventFoodPricing.veg.member"
          nonVegField="freeEventFoodPricing.nonVeg.member"
          validation={validation}
          showVeg={isFoodTypeVeg || isFoodTypeBoth}
          showNonVeg={isFoodTypeNonVeg || isFoodTypeBoth}
        />
      )}
    </PricingBox>

    {/* ================= NON MEMBER ================= */}
    <PricingBox title="Non Member">
      {currentEvent?.includeTicketType === "ADULT_CHILD" ? (
        <>
          {(isFoodTypeVeg || isFoodTypeBoth) && (
            <FoodRow title="Veg">
  <AdultChildInputs
    adultField="freeEventAdultChildPricing.veg.adult.nonMember"
    childField="freeEventAdultChildPricing.veg.child.nonMember"
    validation={validation}
  />
</FoodRow>
          )}

          {(isFoodTypeNonVeg || isFoodTypeBoth) && (
            <FoodRow title="Non Veg">
  <AdultChildInputs
    adultField="freeEventAdultChildPricing.nonVeg.adult.nonMember"
    childField="freeEventAdultChildPricing.nonVeg.child.nonMember"
    validation={validation}
  />
</FoodRow>
          )}
        </>
      ) : (
        <FoodOnlyRow
          vegField="freeEventFoodPricing.veg.nonMember"
          nonVegField="freeEventFoodPricing.nonVeg.nonMember"
          validation={validation}
          showVeg={isFoodTypeVeg || isFoodTypeBoth}
          showNonVeg={isFoodTypeNonVeg || isFoodTypeBoth}
        />
      )}
    </PricingBox>
  </>
)}

                        {/*  */}

                    

                        <div className="mb-3 col-12">
                          <Label
                            htmlFor="end_date"
                            className="text-secondary text-opacity-75"
                          >
                            Booking Ends On
                          </Label>
                          <Input
                            name="end_date"
                            className={`form-control`}
                            type="date"
                            value={
                            validation.values.end_date
                            ? validation.values.end_date.split("T")[0]
                             : ""
                              }

                            // defaultValue={validation.values.end_date || ""}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.end_date &&
                              validation.errors.end_date
                                ? true
                                : false
                            }
                          />
                          {validation.touched.end_date &&
                          validation.errors.end_date ? (
                            <FormFeedback
                              type="invalid"
                              style={{ fontSize: "12px" }}
                            >
                              {validation.errors.end_date}
                            </FormFeedback>
                          ) : null}
                        </div>

                        {/* ) : null} */}
                      </Col>

                      <Col className="d-flex mt-3 justify-content-center">
                        <div className=" text-center mt-3 ">
                          <button
                            type="submit"
                            className="btn btn-success w-md px-5"
                          >
                            {selectedData?._id ? "Update" : "Submit"}
                          </button>
                        </div>
                        <div className=" text-center mt-3 mx-3 ">
                          <button
                            type="button"
                            onClick={Cancel}
                            className="btn btn-danger w-md px-5"
                          >
                            {"Cancel"}
                          </button>
                        </div>
                      </Col>
                    </div>
                  )}
                </Row>
              </Form>
            </OffcanvasBody>
          </Offcanvas>

          {/*delete Modal */}
          <Modal
            isOpen={modal_backdrop}
            toggle={() => {
              tog_backdrop()
            }}
            backdrop={"static"}
            id="staticBackdrop"
          >
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Delete
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={tog_backdrop}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body font-size-15">
              <p>Do you want Delete this Event ?</p>
            </div>
            <div className="modal-footer ">
              <button
                type="button"
                className="btn btn-danger mx-3"
                onClick={() => {
                  dispatch(deleteBookingDetails(delete_data))
                  tog_backdrop()
                }}
              >
                Yes
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={tog_backdrop}
              >
                No
              </button>
            </div>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SeatAllocationList
